import { NotificationPreferenceType } from '@acp/shared';
import { z } from 'zod';

const notificationPreferenceSchema = z.object({
    serviceReportsAutoOwnerEmailPreference: z.nativeEnum(NotificationPreferenceType),
    rmsWorkOrderReceivedEnabled: z.boolean(),
    rmsCheckScheduledEnabled: z.boolean(),
    rmsCheckCancelledEnabled: z.boolean(),
});

// fields saved through the RMS email notification settings endpoint
const rmsEmailNotificationFields = [
    'rmsWorkOrderReceivedEnabled',
    'rmsCheckScheduledEnabled',
    'rmsCheckCancelledEnabled',
] as const;

type NotificationPreferenceFormValues = z.infer<
    typeof notificationPreferenceSchema
>;

export {
    notificationPreferenceSchema,
    rmsEmailNotificationFields,
    NotificationPreferenceFormValues,
};
